import React, { useState } from 'react';

function Layout({ children, activePage }) {
  const [openMenus, setOpenMenus] = useState([]);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [userMenuOpen, setUserMenuOpen] = useState(false);
  const [user, setUser] = useState(() => {
    const userData = localStorage.getItem('user');
    return userData ? JSON.parse(userData) : null;
  });

  const menuItems = [
    { id: 'home', name: 'Ana Sayfa', icon: '🏠' },
    { id: 'status', name: 'Güncel Durum', icon: '📊' },
    { 
      id: 'sales', 
      name: 'Satışlar', 
      icon: '💰', 
      hasSubmenu: true,
      submenu: [
        { id: 'quotes', name: 'Teklifler', icon: '📝' },
        { id: 'invoices', name: 'Faturalar', icon: '📄' },
        { id: 'customers', name: 'Müşteriler', icon: '👥' },
        { id: 'sales-report', name: 'Satışlar Raporu', icon: '📊' },
        { id: 'collections-report', name: 'Tahsilatlar Raporu', icon: '💳' },
        { id: 'income-expense-report', name: 'Gelir Gider Raporu', icon: '📈' },
      ]
    },
    { id: 'expenses', name: 'Giderler', icon: '💸' },
    { id: 'cash', name: 'Nakit', icon: '💵' },
    { id: 'stock', name: 'Stok', icon: '📦' },
    { id: 'ecommerce', name: 'E-Ticaret', icon: '🛒' },
  ];

  const toggleMenu = (menuId) => {
    setOpenMenus(prev => 
      prev.includes(menuId) 
        ? prev.filter(id => id !== menuId)
        : [...prev, menuId]
    );
  };

  const closeMenu = (menuId) => {
    setOpenMenus(prev => prev.filter(id => id !== menuId));
  };

  const handleLogout = () => {
    if (window.confirm('Çıkış yapmak istediğinize emin misiniz?')) {
      localStorage.clear();
      window.location.reload();
    }
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  return (
    <div className="flex h-screen bg-gray-50">
      {/* Mobile Overlay */}
      {mobileMenuOpen && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 z-40 md:hidden"
          onClick={closeMobileMenu}
        />
      )}

      {/* Sidebar */}
      <aside className={`
        fixed md:static inset-y-0 left-0 z-50
        w-64 bg-white shadow-lg flex flex-col
        transform transition-transform duration-300 ease-in-out
        ${mobileMenuOpen ? 'translate-x-0' : '-translate-x-full md:translate-x-0'}
      `}>
        {/* Logo */}
        <div className="p-4 border-b flex items-center justify-between">
          <div className="flex items-center gap-2">
            <img src="/logo.png" alt="Defternet" className="w-10 h-10" />
            <div className="flex items-center gap-2">
              <span className="font-bold text-xl text-gray-800">Defternet</span>
              <span className="px-2 py-0.5 text-xs font-semibold bg-yellow-400 text-gray-800 rounded">BETA</span>
            </div>
          </div>
          {/* Mobilde kapat butonu */}
          <button 
            onClick={closeMobileMenu}
            className="md:hidden text-gray-500 hover:text-gray-700"
          >
            ✕
          </button>
        </div>

        {/* Menu Items */}
        <nav className="flex-1 p-3 space-y-1 overflow-y-auto">
          {menuItems.map((item) => (
            <div 
              key={item.id}
              onMouseLeave={() => item.hasSubmenu && closeMenu(item.id)}
            >
              {/* Ana Menü */}
              <button
                onClick={() => {
                  if (item.hasSubmenu) {
                    toggleMenu(item.id);
                  } else {
                    window.location.href = `/${item.id}`;
                    closeMobileMenu();
                  }
                }}
                className={`w-full flex items-center justify-between px-3 py-2.5 rounded-lg transition ${
                  activePage === item.id
                    ? 'bg-blue-50 text-blue-600 font-medium'
                    : 'text-gray-700 hover:bg-gray-50'
                }`}
              >
                <div className="flex items-center gap-3">
                  <span className="text-lg">{item.icon}</span>
                  <span className="text-sm">{item.name}</span>
                </div>
                {item.hasSubmenu && (
                  <span className="text-xs text-gray-400">
                    {openMenus.includes(item.id) ? '▼' : '▶'}
                  </span>
                )}
              </button>

              {/* Alt Menü */}
              {item.hasSubmenu && openMenus.includes(item.id) && (
                <div className="ml-4 mt-1 space-y-1">
                  {item.submenu.map((subitem) => (
                    <button
                      key={subitem.id}
                      onClick={() => {
                        window.location.href = `/${subitem.id}`;
                        closeMobileMenu();
                      }}
                      className={`w-full flex items-center gap-2 px-3 py-2 rounded-lg transition text-sm ${
                        activePage === subitem.id
                          ? 'bg-blue-50 text-blue-600 font-medium'
                          : 'text-gray-600 hover:bg-gray-50'
                      }`}
                    >
                      <span className="text-base">{subitem.icon}</span>
                      <span>{subitem.name}</span>
                    </button>
                  ))}
                </div>
              )}
            </div>
          ))}
        </nav>

        {/* Footer */}
        <div className="p-4 border-t">
          <div className="text-xs text-gray-500 text-center">
            © 2025 Defternet
          </div>
        </div>
      </aside>

      {/* Main Content */}
      <div className="flex-1 flex flex-col overflow-hidden">
        {/* Top Header */}
        <header className="bg-white shadow-sm px-4 md:px-6 py-4 flex justify-between items-center">
          <div className="flex items-center gap-3">
            {/* Hamburger Menu (Sadece mobilde) */}
            <button 
              onClick={() => setMobileMenuOpen(true)}
              className="md:hidden text-gray-700 p-2 hover:bg-gray-100 rounded-lg"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>

            <div>
              <h1 className="text-lg md:text-xl font-semibold text-gray-800">
                {menuItems.find((item) => item.id === activePage)?.name || 
                 menuItems.flatMap(item => item.submenu || []).find(sub => sub.id === activePage)?.name || 
                 'Ana Sayfa'}
              </h1>
              <p className="text-xs md:text-sm text-gray-500 hidden sm:block">
                {new Date().toLocaleDateString('tr-TR', {
                  weekday: 'long',
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric',
                })}
              </p>
            </div>
          </div>

          {/* User Menu */}
          <div className="flex items-center gap-2 md:gap-4">
            {/* Bildirimler */}
            <button className="relative p-2 text-gray-600 hover:bg-gray-100 rounded-lg">
              <span className="text-lg md:text-xl">🔔</span>
              <span className="absolute top-1 right-1 w-2 h-2 bg-red-500 rounded-full"></span>
            </button>

            {/* User Dropdown - Mobile & Desktop */}
            <div className="relative">
              <button
                onClick={() => setUserMenuOpen(!userMenuOpen)}
                className="flex items-center gap-3 px-3 py-2 bg-gray-50 rounded-lg hover:bg-gray-100 transition"
              >
                <div className="w-10 h-10 bg-blue-500 rounded-full flex items-center justify-center text-white font-semibold">
                  {user?.business_name?.charAt(0) || user?.email?.charAt(0) || 'U'}
                </div>
                <div className="text-sm hidden md:block">
                  <p className="font-medium text-gray-800">
                    {user?.business_name || 'Kullanıcı'}
                  </p>
                  <p className="text-xs text-gray-500">{user?.email}</p>
                </div>
                <span className="text-gray-400 text-xs hidden md:inline">{userMenuOpen ? '▲' : '▼'}</span>
              </button>

              {/* Dropdown Menu */}
              {userMenuOpen && (
                <>
                  {/* Overlay */}
                  <div 
                    className="fixed inset-0 z-10" 
                    onClick={() => setUserMenuOpen(false)}
                  />
                  
                  {/* Menu */}
                  <div className="absolute right-0 mt-2 w-56 bg-white rounded-lg shadow-lg border border-gray-200 py-2 z-20">
                    <button
                      onClick={() => {
                        setUserMenuOpen(false);
                        window.location.href = '/profile';
                      }}
                      className="w-full px-4 py-2.5 text-left hover:bg-gray-50 flex items-center gap-3 text-sm text-gray-700"
                    >
                      <span>👤</span>
                      <span>Profilim</span>
                    </button>
                    
                    <button
                      onClick={() => {
                        setUserMenuOpen(false);
                        // TODO: Navigate to settings
                      }}
                      className="w-full px-4 py-2.5 text-left hover:bg-gray-50 flex items-center gap-3 text-sm text-gray-700"
                    >
                      <span>⚙️</span>
                      <span>Ayarlar</span>
                    </button>
                    
                    <button
                      onClick={() => {
                        setUserMenuOpen(false);
                        // TODO: Navigate to support
                      }}
                      className="w-full px-4 py-2.5 text-left hover:bg-gray-50 flex items-center gap-3 text-sm text-gray-700"
                    >
                      <span>📧</span>
                      <span>Destek</span>
                    </button>
                    
                    <hr className="my-2 border-gray-200" />
                    
                    <button
                      onClick={handleLogout}
                      className="w-full px-4 py-2.5 text-left hover:bg-red-50 flex items-center gap-3 text-sm text-red-600"
                    >
                      <span>🚪</span>
                      <span>Çıkış</span>
                    </button>
                  </div>
                </>
              )}
            </div>
          </div>
        </header>

        {/* Page Content */}
        <main className="flex-1 overflow-y-auto p-4 md:p-6">{children}</main>
      </div>
    </div>
  );
}

export default Layout;